import { useSnackbarStore } from '@/store/snackbar';

export function snackbarPush(text: string, closable = false, timeout = 2000) {
  useSnackbarStore().push({
    text: text,
    closable: closable,
    timeout: timeout,
  });
}
